// Import model
import { StartObjectFileAskSyntheaRequest } from '../models/StartObjectFileAskSyntheaRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartObjectFileAskSyntheaRequest - handles JSON serialization and deserialization with type validation
 */
export class StartObjectFileAskSyntheaRequestSerializer {
  /**
   * Deserializes a JSON string into a StartObjectFileAskSyntheaRequest instance
   */
  static deserialize(json: string): StartObjectFileAskSyntheaRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartObjectFileAskSyntheaRequest instance
   */
  static fromObject(obj: any): StartObjectFileAskSyntheaRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartObjectFileAskSyntheaRequest');
    }


    const instance: StartObjectFileAskSyntheaRequest = {
      assistantId: obj['AssistantId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartObjectFileAskSyntheaRequest instances
   */
  static deserializeArray(json: string): StartObjectFileAskSyntheaRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartObjectFileAskSyntheaRequest instance to a JSON string
   */
  static serialize(instance: StartObjectFileAskSyntheaRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartObjectFileAskSyntheaRequest instance to a plain object
   */
  static toObject(instance: StartObjectFileAskSyntheaRequest): any {
    return {
      'AssistantId': instance.assistantId,
    };
  }

  /**
   * Serializes an array of StartObjectFileAskSyntheaRequest instances to a JSON string
   */
  static serializeArray(instances: StartObjectFileAskSyntheaRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
